import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';

const personIdToUserIdCache = new Map<number, string | null>();
const checkpointAvailabilityCache = new Map<string, boolean>();

export async function getRunnerRouteIdByPersonId(personId: number): Promise<string | null> {
  if (!Number.isFinite(personId)) {
    return null;
  }
  const cached = personIdToUserIdCache.get(personId);
  if (cached !== undefined) {
    return cached;
  }

  const profilesRef = collection(db, 'publicProfiles');
  const q = query(profilesRef, where('personId', '==', personId), limit(1));
  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    personIdToUserIdCache.set(personId, null);
    return null;
  }

  const docSnap = snapshot.docs[0];
  const data = docSnap.data() as { personId?: number | string | null };
  const fromField = typeof data.personId === 'number' ? data.personId : Number(data.personId);
  const resolved = Number.isFinite(fromField) ? String(fromField) : docSnap.id;
  const routeId = resolved.trim();
  personIdToUserIdCache.set(personId, routeId);
  return routeId;
}

// Backwards compat: legacy name used by KUTC pages.
export async function getUserIdByPersonId(personId: number): Promise<string | null> {
  return getRunnerRouteIdByPersonId(personId);
}

export async function hasCheckpointAnalysis(editionId: string, personId: number): Promise<boolean> {
  if (!editionId || !Number.isFinite(personId)) {
    return false;
  }
  const key = `${editionId}::${personId}`;
  if (checkpointAvailabilityCache.has(key)) {
    return checkpointAvailabilityCache.get(key) ?? false;
  }

  const checkpointsRef = collection(db, 'checkpointResults');
  const q = query(
    checkpointsRef,
    where('eventEditionId', '==', editionId),
    where('personId', '==', personId),
    limit(1)
  );
  const snapshot = await getDocs(q);
  const hasData = !snapshot.empty;
  checkpointAvailabilityCache.set(key, hasData);
  return hasData;
}
